export enum EnumPackageType {
  NotSet = 0,
  SinglePacking = 1,
  CompositePacking = 2,
  InnerPacking = 3,
  Overpack = 4,
  Tank = 5,
  Bulk = 6,
  CompositePacking_DG = 7,
  CompositePacking_EQ = 8,
  CompositePacking_LQ = 9
}
